
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import 'react-loading-skeleton/dist/skeleton.css';

ChartJS.register(ArcElement, Tooltip, Legend);


export default function Chart3({ resgistered = 0, actives = 0 }) {
  const total = resgistered + actives;

  const hasValidData = total > 0;

  const data = hasValidData
    ? {
        labels: [
          `Registrados (${((resgistered / total) * 100).toFixed(1)}%)`,
          `Activos (${((actives / total) * 100).toFixed(1)}%)`,
        ],
        datasets: [
          {
            data: [resgistered, actives],
            backgroundColor: ['#36b9cc', '#f6c23e'],
          },
        ],
      }
    : {
        labels: [],
        datasets: [],
      };

  const options = {
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
    },
  };

  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <div style={{ width: '100%', maxWidth: '350px' }}>
        {hasValidData ? (
          <Pie data={data} options={options} />
        ) : (
          <p>No hay datos para mostrar.</p>
        )}
      </div>
    </div>
  );
}
